export default __webpack_public_path__ + "static/media/lock.dea2d946.svg";